module.exports = __webpack_public_path__ + "img/weibo.1eb36541.png";